import Axios from "axios";
var ThirdPartySystemService = (function () {
    function ThirdPartySystemService() {
    }
    ThirdPartySystemService.createInstance = function () {
        ThirdPartySystemService.getInstance();
    };
    ThirdPartySystemService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    ThirdPartySystemService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/agent_warehouse/list", { params: params });
    };
    ThirdPartySystemService.prototype.save = function (params) {
        return Axios.post("supplierclientapi/agent_warehouse/save", params);
    };
    ThirdPartySystemService.prototype.getDetail = function (params) {
        return Axios.post("supplierclientapi/agent_warehouse/detail", params);
    };
    ThirdPartySystemService.prototype.getSupplyGoods = function (params) {
        return Axios.get("supplierclientapi/agent_warehouse_goods/list", { params: params });
    };
    ThirdPartySystemService.prototype.bindGoods = function (params) {
        return Axios.post("supplierclientapi/agent_warehouse_goods/do_bind", params);
    };
    ThirdPartySystemService.prototype.unbindGoods = function (params) {
        return Axios.post("supplierclientapi/agent_warehouse_goods/unBind", params);
    };
    ThirdPartySystemService.prototype.quickBindGoods = function (params) {
        return Axios.get("supplierclientapi/agent_warehouse_goods/quick_goods_bind", { params: params });
    };
    ThirdPartySystemService.prototype.syncScmConfig = function (params) {
        return Axios.post("supplierclientapi/agent_warehouse/syncScmConfig", params);
    };
    ThirdPartySystemService.prototype.syncScmGoods = function (params) {
        return Axios.post("supplierclientapi/agent_warehouse/syncScmGoods", params);
    };
    ThirdPartySystemService.prototype.syncScmShop = function (params) {
        return Axios.post("supplierclientapi/agent_warehouse/syncScmShop", params);
    };
    ThirdPartySystemService.prototype.syncScmDepot = function (params) {
        return Axios.post("supplierclientapi/agent_warehouse/syncScmDepot", params);
    };
    ThirdPartySystemService.prototype.verifyScmUserPermission = function (params) {
        return Axios.post("supplierclientapi/agent_warehouse/verifyScmUserPermission", params);
    };
    ThirdPartySystemService.prototype.getScmGoodTypeTree = function (params) {
        return Axios.get("supplierclientapi/agent_warehouse/getScmGoodsTypeTree", { params: params });
    };
    ThirdPartySystemService.prototype.getScmGoodsList = function (params) {
        return Axios.get("supplierclientapi/agent_warehouse/getScmGoodsList", { params: params });
    };
    ThirdPartySystemService.prototype.getScmShopList = function (params) {
        return Axios.get("supplierclientapi/agent_warehouse/getScmShopList", { params: params });
    };
    ThirdPartySystemService.prototype.getScmDeliveryById = function (params) {
        return Axios.get("supplierclientapi/agent_warehouse/getScmDeliveryById", { params: params });
    };
    ThirdPartySystemService.prototype.getScmDeliveryDepots = function (params) {
        return Axios.get("supplierclientapi/agent_warehouse/getScmDeliveryDepots", { params: params });
    };
    ThirdPartySystemService.prototype.exportError = function (params) {
        return Axios.get("supplierclientapi/agent_warehouse/export_error", {
            params: params,
            responseType: 'blob'
        });
    };
    ThirdPartySystemService.prototype.updateInitStatus = function () {
        return Axios.post('supplierclientapi/agent_warehouse/updateInitStatus');
    };
    return ThirdPartySystemService;
}());
export default ThirdPartySystemService;
